import { getFormData, getNewVersionFormData } from '../utils';
import axios from 'axios';

export const uploadFile = async (
  file: any,
  site: string,
  path: string,
  fileExistCheck: boolean,
  onProgress: Function
) => {
  const formData = getFormData(file, site, path, fileExistCheck);
  const token = encodeURIComponent(window.Alfresco.util.CSRFPolicy.getToken());

  return axios({
    method: 'post',
    url: `${window.appContext}/proxy/alfresco/api/upload?${window.Alfresco.util.CSRFPolicy.getParameter()}=${token}`,
    data: formData,
    headers: {
      [window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
    },
    onUploadProgress: event => onProgress(event),
  })
    .then(response => {
      if (response.status !== 200) {
        throw response.data;
      }

      return {
        ...response.data,
      };
    })
    .catch(reason => {
      throw reason?.response?.data?.message || 'Error';
    });
};

export const uploadNewVersion = async (
  file: any,
  nodeRef: string,
  majorVersion: boolean,
  desc: string,
  onProgress: Function
) => {
  const formData = getNewVersionFormData(file, nodeRef, desc);
  const token = encodeURIComponent(window.Alfresco.util.CSRFPolicy.getToken());

  return axios({
    method: 'post',
    url: `${
      window.appContext
    }/proxy/alfresco/emvc/files/upgrade?${window.Alfresco.util.CSRFPolicy.getParameter()}=${token}${
      majorVersion ? '&major=true' : ''
    }`,
    data: formData,
    headers: {
      [window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
    },
    onUploadProgress: event => onProgress(event),
  })
    .then(response => {
      if (response.status !== 200) {
        throw response.data;
      }

      return {
        ...response.data,
      };
    })
    .catch(reason => {
      throw reason?.response?.data?.message || 'Error';
    });
};

export const updateActivity = (data: any) => {
  const token = window.Alfresco.util.CSRFPolicy.getToken();
  return fetch(
    `${
      window.appContext
    }/proxy/alfresco/slingshot/doclib/activity?${window.Alfresco.util.CSRFPolicy.getParameter()}=${token}`,
    {
      credentials: 'same-origin',
      body: JSON.stringify(data),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        [window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
      },
    }
  );
};

export const revertVersion = (nodeRef: string, version: string, newVersionData: any) => {
  const token = window.Alfresco.util.CSRFPolicy.getToken();
  return fetch(
    `${window.appContext}/proxy/alfresco-api/-default-/public/alfresco/versions/1/nodes/${nodeRef.replace(
      'workspace://SpacesStore/',
      ''
    )}/versions/${version}/revert?${window.Alfresco.util.CSRFPolicy.getParameter()}=${token}`,
    {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify(newVersionData),
      headers: {
        [window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
      },
    }
  )
    .then(response => {
      if (response.status !== 200) {
        throw new Error(response.statusText);
      }

      return response.json();
    })
    .catch(reason => {
      throw reason;
    });
};
